export enum StorageId {
  IdToken = 'id_token',
  ExpiresAt = 'expires_at',
  EmailOverride = 'email_override',
}
